<div class="drag-zone" appDnd (fileDropped)="onFileDropped($event)">

  <div class="files-list">
    <div class="single-file" *ngFor="let file of files; let i = index">
      <div class="info">
        <p class="name">
          {{ file?.name }} ( {{ formatBytes(file?.size) }} )
        </p>
      </div>
      <mat-icon class="material-icons"  (click)="deleteFile(i)">delete_outline</mat-icon>
    </div>
  </div>

    <div class="card button-card center" (click)="fileDropRef.click()">
      <mat-icon class="mat-18">note_add</mat-icon>
      {{'Upload.button' | translate}}
    </div>
    <input hidden type="file" title=" " #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" 
    name="Sélect. fichiers" [accept]="acceptedFilesType.join()" />
  <div class="file-limit">
    <span [translate]="'Upload.maxSize'" [translateParams]="{'size': sizeLimitMb}"></span>
    <span [translate]="'Upload.allowedTypes'" [translateParams]="{'types': acceptedFilesType.join(', ').toUpperCase()}"></span>
  </div>

  <p class="error" *ngIf="this.sizeLimitError === true" [translate]="'Upload.maxSizeError'" [translateParams]="{'size': sizeLimitMb}"></p>
  <p class="error" *ngIf="this.numberLimitError === true" [translate]="'Upload.numberLimitError'"></p>
  <p class="error" *ngIf="this.fileTypeError === true" [translate]="'Upload.allowedTypesError'"></p>
</div>
